<template>
    <b-modal
        id="destroy"
        title="Deletar Comentário"
        hide-footer>
        <b-overlay :show="loading" rounded="sm">

            <p>
                Tem certeza que deseja deletar o comentário de atalho <b>{{ name }}</b> ?
            </p>

            <!-- Destroy -->
            <b-button type="button" variant="danger" :disable="loading" @click="destroy">
                Deletar Comentário
            </b-button>

        </b-overlay>
    </b-modal>
</template>

<script>
export default {
    props: ['endpoint'],
    data() {
        return {
            loading: false,
            id: null,
            name: null
        }
    },
    created() {
        this.$root.$on('destroyPreComment', (event) => {

            // Set Form
            this.id = event.id
            this.name = event.name

            // Modal
            this.$bvModal.show('destroy')

        })
    },
    methods: {

        destroy() {
            this.loading = true;
            axios.delete(this.endpoint + '/' + this.id)
                .then((result) => {
                    // Callback
                    this.$emit('destroyed')

                    // Close Modal
                    this.$bvModal.hide('destroy')

                    // Message
                    this.$toast.success('Comentário deletado com sucesso !')

                    // Clear Form
                    this.name = null
                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
